
const POSTCODE_KEY = 'divano:freight-postcode';
const KLAVIYO_REVISION = '2026-07-15';
const SEND_TIMEOUT_MS = 20000;
const BIND_WAIT_MS = 15000;
const TOKEN_WAIT_MS = 20000;
const CHALLENGE_GRACE_MS = 2500;
const SLOW_NOTE_MS = 2500;
const SLOW_NOTE = 'Still sending, this can take a few seconds.';

function publish(name, payload) {
  try {
     (window).Shopify?.analytics?.publish?.(name, payload);
  } catch (error) {
  }
}

function rememberedPostcode() {
  for (const area of ['sessionStorage', 'localStorage']) {
    try {
      const value = ( (window)[area].getItem(POSTCODE_KEY) || '').trim();
      if (/^\d{4}$/.test(value)) return value;
    } catch (error) {
    }
  }
  return '';
}

const isShown = (el) =>
  typeof ( (el).checkVisibility) === 'function'
    ?  (el).checkVisibility()
    : el.getClientRects().length > 0;

function init() {
  const dialog = document.getElementById('DivanoMessageDialog');
  if (!(dialog instanceof HTMLDialogElement)) return;
  const form = dialog.querySelector('#DivanoMessageForm');
  if (!(form instanceof HTMLFormElement)) return;

  const productId = Number(dialog.dataset.productId) || null;
  const productTitle = dialog.dataset.productTitle || '';
  let variants = {};
  try {
    variants = JSON.parse(dialog.querySelector('[data-message-variants]')?.textContent || '{}');
  } catch (error) {
    variants = {};
  }

  const field = (name) =>  (form.querySelector(`[data-message-field="${name}"]`));
  const input = (name) =>
     (form.querySelector(`[data-message-input="${name}"]`));

  const title =  (dialog.querySelector('#DivanoMessageTitle'));
  const body =  (dialog.querySelector('[data-message-body]'));
  const done =  (dialog.querySelector('[data-message-done]'));
  const doneTitle =  (dialog.querySelector('[data-message-done-title]'));
  const optinConfirm =  (dialog.querySelector('[data-message-optin-confirm]'));
  let messageGeneration = 0;
  const answer =  (dialog.querySelector('[data-message-answer]'));
  const answerText =  (dialog.querySelector('[data-message-answer-text]'));
  const status =  (form.querySelector('[data-message-status]'));
  const submit =  (form.querySelector('[data-message-submit]'));
  const optin =  (form.querySelector('[data-message-optin]'));
  const aboutVariant =  (dialog.querySelector('[data-message-about-variant]'));
  const aboutVariantTitle =  (dialog.querySelector('[data-message-about-variant-title]'));
  const submitLabel = submit?.textContent || 'Send message';

  let opener = null;
  let active = null;
  let chipUsed = null;
  let lastPrefill = '';
  let sending = false;
  let needsHandoff = false;
  let nativeNext = false;
  let handoffTimer;
  const handoffStorageKey = `divano:message-handoff:${window.location.pathname}`;
  let steppedAside = false;
  let downOnBackdrop = false;
  const subscribed = new Set();

  function setVariant(id) {
    const variant = variants[id];
    if (!variant) return;
    const sku = (variant.sku || '').trim();
    const subject = field('subject');
    const variantField = field('variant');
    const skuField = field('sku');
    const variantId = field('variant-id');
    const page = field('page');
    if (subject) subject.value = `Product question: ${productTitle}${sku ? ` (${sku})` : ''}`;
    if (variantField) variantField.value = variant.title || '';
    if (skuField) skuField.value = sku;
    if (variantId) variantId.value = id;
    if (page) page.value = `${window.location.origin}${window.location.pathname}?variant=${id}`;
    if (aboutVariantTitle) aboutVariantTitle.textContent = variant.title || '';
    if (aboutVariant) aboutVariant.hidden = !variant.title;
  }

  function selectedVariantId() {
    const inputs = document.querySelectorAll(
      `main product-form-component[data-product-id="${productId}"] input[name="id"], main form[action*="/cart/add"] input[name="id"]`
    );
    for (const el of inputs) {
      const value =  (el).value;
      if (variants[value]) return value;
    }
    try {
      const fromUrl = new URL(window.location.href).searchParams.get('variant') || '';
      if (variants[fromUrl]) return fromUrl;
    } catch (error) {
    }
    return field('variant-id')?.value || '';
  }

  document.addEventListener('variant:update', (event) => {
    const id = String( (event).detail?.resource?.id ?? '');
    if (id && variants[id]) setVariant(id);
  });

  function leadTimeCopy() {
    const selected = selectedVariantId();
    const rows = document.querySelectorAll(`main divano-lead-time-row[data-product-id="${productId}"]`);
    for (const row of rows) {
      if (!(row instanceof HTMLElement) || row.hidden || row.closest('[hidden]')) continue;
      if (selected && row.dataset.currentVariantId && row.dataset.currentVariantId !== selected) continue;
      const copy = row.querySelector('[data-role="copy"]');
      const text = (copy?.textContent || '').replace(/\s+/g, ' ').trim();
      if (text && copy && isShown(copy)) return text;
    }
    return '';
  }

  function focusables() {
    return  (
      [...dialog.querySelectorAll('button, a[href], input, textarea, select, [tabindex]:not([tabindex="-1"])')]
    ).filter(
      (el) =>
        !( (el).disabled) &&
         (el).type !== 'hidden' &&
        !el.closest('[hidden]') &&
        el.getClientRects().length > 0
    );
  }

  function setAnswerClosed() {
    if (answer) answer.hidden = true;
    if (answerText) answerText.replaceChildren();
    dialog.querySelectorAll('[data-message-chip][aria-expanded]').forEach((chip) => chip.setAttribute('aria-expanded', 'false'));
    active = null;
  }

  function prefill(text, key) {
    const box = input('question');
    if (!box) return;
    const current = box.value.trim();
    if (current && current !== lastPrefill.trim()) return;
    box.value = text;
    lastPrefill = text;
    chipUsed = { key, label: text };
    const chipField = field('chip');
    if (chipField) {
      chipField.value = text;
      chipField.disabled = false;
    }
    clearError(box);
  }

  function showAnswer(chip, kind, key, label, nodes) {
    if (!answer || !answerText) return;
    setAnswerClosed();
    answerText.replaceChildren(...nodes);
    answer.hidden = false;
    chip.setAttribute('aria-expanded', 'true');
    active = { kind, key, label, el: chip };
    answer.focus({ preventScroll: true });
    answer.scrollIntoView({ block: 'nearest' });
  }

  function onChip(chip) {
    const kind = chip.dataset.messageChip || '';
    const key = chip.dataset.chipKey || '';
    const label = (chip.textContent || '').replace(/\s+/g, ' ').trim();
    if (active && active.el === chip) {
      setAnswerClosed();
      return;
    }
    publish('divano_message_chip', { kind, key, resolved: false });

    if (kind === 'faq') {
      const source = [...dialog.querySelectorAll('[data-faq-answer]')].find(
        (el) =>  (el).dataset.faqAnswer === key
      );
      if (source) showAnswer(chip, kind, key, label, [...source.cloneNode(true).childNodes]);
      return;
    }

    prefill(label, key);
    if (key === 'delivery') {
      setAnswerClosed();
      input('postcode')?.focus();
      return;
    }
    let nodes = [];
    if (key === 'stock') {
      const copy = leadTimeCopy();
      if (copy) {
        const p = document.createElement('p');
        p.textContent = copy;
        nodes = [p];
      }
    } else {
      const source = [...dialog.querySelectorAll('[data-prefill-answer]')].find(
        (el) =>  (el).dataset.prefillAnswer === key
      );
      if (source) {
        const clone =  (source.cloneNode(true));
        clone.removeAttribute('data-prefill-answer');
        nodes = [clone];
      }
    }
    if (nodes.length) {
      showAnswer(chip, kind, key, label, nodes);
    } else {
      setAnswerClosed();
      input('question')?.focus();
    }
  }

  function onResolved() {
    if (!active) return;
    publish('divano_message_chip', { kind: active.kind, key: active.key, resolved: true });
    const box = input('question');
    if (box && lastPrefill && box.value.trim() === lastPrefill.trim() && chipUsed?.key === active.key) {
      box.value = '';
      lastPrefill = '';
      chipUsed = null;
      const chipField = field('chip');
      if (chipField) {
        chipField.value = '';
        chipField.disabled = true;
      }
    }
    setAnswerClosed();
    dialog.close();
  }

  function onStillAsking() {
    if (!active) return;
    if (active.kind === 'faq') prefill(active.label, active.key);
    setAnswerClosed();
    const box = input('question');
    if (box) {
      box.focus();
      box.setSelectionRange(box.value.length, box.value.length);
    }
  }

  function setError(el, message) {
    const error = el.getAttribute('aria-describedby') ? document.getElementById(el.getAttribute('aria-describedby') || '') : null;
    el.setAttribute('aria-invalid', 'true');
    if (error) {
      error.textContent = message;
      error.hidden = false;
    }
  }

  function clearError(el) {
    const error = el.getAttribute('aria-describedby') ? document.getElementById(el.getAttribute('aria-describedby') || '') : null;
    el.removeAttribute('aria-invalid');
    if (error) {
      error.textContent = '';
      error.hidden = true;
    }
  }

  function validate() {
    const invalid = [];
    const email = input('email');
    const phone = input('phone');
    const postcode = input('postcode');
    const question = input('question');
    for (const el of [email, phone, postcode, question]) if (el) clearError(el);

    if (email) {
      const value = email.value.trim();
      if (!value) {
        setError(email, 'Enter your email address.');
        invalid.push({ el: email, name: 'Email' });
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        setError(email, 'Enter an email address like name@example.com.');
        invalid.push({ el: email, name: 'Email' });
      }
    }
    if (phone && phone.value.trim()) {
      const digits = phone.value.replace(/[\s().+-]/g, '');
      if (!/^\d{8,15}$/.test(digits)) {
        setError(phone, 'Enter a phone number, or leave it blank.');
        invalid.push({ el: phone, name: 'Phone' });
      }
    }
    if (postcode && postcode.value.trim() && !/^\d{4}$/.test(postcode.value.trim())) {
      setError(postcode, 'Enter a 4-digit postcode, or leave it blank.');
      invalid.push({ el: postcode, name: 'Postcode' });
    }
    if (question && !question.value.trim()) {
      setError(question, 'Enter your question.');
      invalid.push({ el: question, name: 'Your question' });
    }

    if (status) status.textContent = invalid.length ? `Please check: ${invalid.map((i) => i.name).join(', ')}.` : '';
    if (invalid[0]) invalid[0].el.focus();
    return invalid.length === 0;
  }

  function subscribe(email, name = '') {
    const company = dialog.dataset.klaviyoCompany || '';
    const list = dialog.dataset.klaviyoList || '';
    const key = email.toLowerCase();
    if (!company || !list || subscribed.has(key)) return Promise.resolve(false);
    subscribed.add(key);
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Product page message form',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                ...(name ? { first_name: name.split(' ')[0], ...(name.includes(' ') ? { last_name: name.slice(name.indexOf(' ') + 1) } : {}) } : {}),
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
              },
            },
          },
        },
        relationships: { list: { data: { type: 'list', id: list } } },
      },
    };
    try {
      return fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(company)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: KLAVIYO_REVISION },
        body: JSON.stringify(payload),
      }).then(
        (response) => {
          if (!response.ok) subscribed.delete(key);
          return response.ok;
        },
        () => {
          subscribed.delete(key);
          return false;
        }
      );
    } catch (error) {
      subscribed.delete(key);
      return Promise.resolve(false);
    }
  }

  async function classify(response) {
    let url;
    try {
      url = new URL(response.url, window.location.href);
    } catch (error) {
      url = null;
    }
    if (url && /^\/challenge\b/.test(url.pathname)) return { outcome: 'challenge' };
    if (!response.ok) return { outcome: 'error' };
    if (url && url.searchParams.get('contact_posted') === 'true') return { outcome: 'sent' };
    let doc;
    try {
      doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    } catch (error) {
      return { outcome: 'unknown' };
    }
    if (doc.querySelector('#DivanoMessageForm [data-message-posted]')) return { outcome: 'sent' };
    const errors = doc.querySelector('#DivanoMessageForm [data-message-server-errors]');
    if (errors) return { outcome: 'invalid', message: (errors.textContent || '').replace(/\s+/g, ' ').trim() };
    if (doc.querySelector('.h-captcha, [data-hcaptcha], iframe[src*="hcaptcha"], form[action*="challenge"]')) {
      return { outcome: 'challenge' };
    }
    return { outcome: 'unknown' };
  }

  function sentPayload() {
    return {
      product_id: productId,
      has_phone: Boolean(input('phone')?.value.trim()),
      has_postcode: Boolean(input('postcode')?.value.trim()),
      chip: chipUsed ? chipUsed.key : null,
      opted_in: Boolean(optin && optin.checked),
    };
  }

  function showDone() {
    if (body) body.hidden = true;
    if (done) done.hidden = false;
    doneTitle?.focus();
  }

  function resetForNextMessage() {
    messageGeneration++;
    if (optinConfirm) optinConfirm.hidden = true;
    form.reset();
    for (const name of ['name', 'email', 'phone', 'postcode', 'question']) {
      const el = input(name);
      if (el) clearError(el);
    }
    const chipField = field('chip');
    if (chipField) {
      chipField.value = '';
      chipField.disabled = true;
    }
    if (status) status.textContent = '';
    needsHandoff = false;
    if (submit) submit.hidden = false;
    status?.classList.remove('divano-message__status--step');
    chipUsed = null;
    lastPrefill = '';
    setAnswerClosed();
    if (body) body.hidden = false;
    if (done) done.hidden = true;
  }

  function open(trigger) {
    if (dialog.open) return;
    steppedAside = false;
    opener = trigger;
    if (done && !done.hidden) resetForNextMessage();
    const id = selectedVariantId();
    if (id) setVariant(id);
    const postcode = input('postcode');
    if (postcode && !postcode.value) postcode.value = rememberedPostcode();
    dialog.showModal();
    title?.focus();
    prebind();
    publish('divano_message_form_open', { surface: trigger.dataset.divanoMessageSurface || 'pdp', product_id: productId });
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('[data-divano-message-open]') : null;
    if (!(trigger instanceof HTMLElement)) return;
    event.preventDefault();
    open(trigger);
  });

  dialog.addEventListener('pointerdown', (event) => {
    downOnBackdrop = event.target === dialog;
  });

  dialog.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (target === dialog) {
      if (downOnBackdrop) dialog.close();
      return;
    }
    if (target.closest('[data-divano-message-close]')) {
      dialog.close();
      return;
    }
    const chip = target.closest('[data-message-chip]');
    if (chip instanceof HTMLElement) {
      onChip(chip);
      return;
    }
    if (target.closest('[data-message-resolved]')) onResolved();
    else if (target.closest('[data-message-still]')) onStillAsking();
  });

  dialog.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    const items = focusables();
    if (!items.length) return;
    const current =  (document.activeElement);
    const index = items.indexOf( (current));
    if (index === -1 && current && dialog.contains(current) && current !== title) return;
    const wrap = event.shiftKey ? index <= 0 : index === -1 || index === items.length - 1;
    if (wrap) {
      event.preventDefault();
      (event.shiftKey ? items[items.length - 1] : items[0]).focus();
    }
  });

  dialog.addEventListener('close', () => {
    if (steppedAside || dialog.open) return;
    const target =
      opener && opener.isConnected
        ? opener
        :  (document.querySelector('[data-divano-message-open]'));
    target?.focus();
    if (done && !done.hidden) resetForNextMessage();
    else setAnswerClosed();
  });

  form.addEventListener('input', (event) => {
    const el = event.target;
    if ((el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) && el.getAttribute('aria-invalid')) clearError(el);
  });

  let slowNote;
  let sendStarted = false;
  let tokenWatch;
  let optinEmail = '';
  let optinName = '';
  let payload = null;

  function finishSending() {
    sending = false;
    sendStarted = false;
    clearInterval(tokenWatch);
    clearTimeout(slowNote);
    if (status && status.textContent === SLOW_NOTE) status.textContent = '';
    if (submit) {
      submit.disabled = false;
      submit.removeAttribute('data-divano-busy');
      submit.removeAttribute('aria-busy');
      submit.textContent = submitLabel;
    }
  }

  function comeBack() {
    if (!dialog.open) dialog.showModal();
    steppedAside = false;
  }

  let prebinding = false;
  function prebind() {
    if (prebinding || form.hasAttribute('data-hcaptcha-bound')) return;
    const captcha =  (window).Shopify?.captcha;
    if (!captcha || typeof captcha.protect !== 'function') return;
    prebinding = true;
    try {
      captcha.protect(form, () => {});
    } catch (error) {
      prebinding = false;
    }
  }

  function failedNote() {
    const phone = dialog.dataset.fallbackPhone || '';
    const email = dialog.dataset.fallbackEmail || '';
    const nodes = [`${FAILED} Please try again in a moment`];
    if (phone) nodes.push(email ? `, call us on ${phone}` : ` or call us on ${phone}`);
    if (email) {
      const address = Object.assign(document.createElement('span'), { className: 'divano-message__address', textContent: email });
      nodes.push(', or email us at ', address, '.');
    } else {
      nodes.push('.');
    }
    return nodes;
  }

  function fail(message, reason = 'unknown') {
    form.dataset.sendFailure = reason;
    console.info('[divano-message] not sent:', reason);
    publish('divano_message_failed', { product_id: productId, reason });
    payload = null;
    finishSending();
    comeBack();
    if (status) {
      const debug = /[?&]divano_debug=1(?:&|$)/.test(window.location.search) ? ` [${reason}]` : '';
      if (message === FAILED) status.replaceChildren(...failedNote(), debug);
      else status.textContent = message + debug;
    }
    title?.focus();
  }

  function showHandoff() {
    payload = null;
    finishSending();
    comeBack();
    needsHandoff = true;
    if (submit) submit.hidden = true;
    if (!status) return;
    status.classList.add('divano-message__status--step');
    const heading = document.createElement('h3');
    heading.className = 'divano-message__done-title';
    heading.textContent = 'One more step';
    const copy = document.createElement('p');
    copy.textContent = "Please confirm you're human to send your message. We'll bring you straight back.";
    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'button divano-message__submit';
    next.textContent = 'Continue';
    next.addEventListener('click', () => handoff(next));
    status.replaceChildren(heading, copy, next);
    next.focus();
  }

  function handoff(next) {
    if (sending) return;
    const id = selectedVariantId();
    if (id) setVariant(id);
    const key = Array.from({ length: 32 }, () => Math.random().toString(36)[2]).join('');
    let keyField =  (form.querySelector('input[name="form_key"]'));
    if (!keyField) {
      keyField = Object.assign(document.createElement('input'), { type: 'hidden', name: 'form_key' });
      form.append(keyField);
    }
    keyField.value = key;
    const back = new URL(window.location.href);
    for (const name of ['contact_posted', 'form_key', 'form_type']) back.searchParams.delete(name);
    back.searchParams.set('form_key', key);
    back.searchParams.set('form_type', 'contact');
    back.hash = '';
    const returnTo = back.pathname + back.search;
    const action = new URL(form.action);
    action.searchParams.set('return_to', returnTo);
    form.action = action.href;
    let returnField =  (form.querySelector('input[name="return_to"]'));
    if (!returnField) {
      returnField = Object.assign(document.createElement('input'), { type: 'hidden', name: 'return_to' });
      form.append(returnField);
    }
    returnField.value = returnTo;
    try {
      const storage = window.sessionStorage;
      storage.removeItem(handoffStorageKey);
      const excluded = ['recaptcha-v3-token', 'g-recaptcha-response', 'h-captcha-response', 'password',
        ...[...form.querySelectorAll('input[type="password"]')].map((el) => el.name)];
      const data = {};
      for (const [name, value] of new FormData(form)) if (!excluded.includes(name)) data[name] = value;
      storage.setItem(key, JSON.stringify({ __shopify_v: 1, action: form.action, data }));
      storage.setItem(handoffStorageKey, JSON.stringify({
        key, payload: sentPayload(), email: input('email')?.value.trim() || '',
        name: input('name')?.value.trim().replace(/\s+/g, ' ') || '', chip: chipUsed,
      }));
    } catch (error) {
    }
    sending = true;
    next.disabled = true;
    if (form.hasAttribute('data-hcaptcha-bound') && typeof form.submit === 'function') {
      steppedAside = true;
      dialog.close();
      nativeNext = true;
      clearTimeout(handoffTimer);
      handoffTimer = setTimeout(() => {
        if (!nativeNext) return;
        nativeNext = false;
        next.disabled = false;
        sending = false;
        fail(FAILED, 'handoff-token-timeout');
      }, TOKEN_WAIT_MS);
      form.submit();
      return;
    }
    try {
      HTMLFormElement.prototype.submit.call(form);
    } catch (error) {
      needsHandoff = false;
      if (submit) submit.hidden = false;
      status?.classList.remove('divano-message__status--step');
      try { window.sessionStorage.removeItem(handoffStorageKey); } catch (error) {  }
      fail(FAILED, 'handoff-error');
    }
  }

  function confirmSent(sent, email, name) {
    publish('divano_message_sent', sent);
    if (sent && sent.opted_in) {
      const generation = messageGeneration;
      subscribe(email, name).then((accepted) => {
        if (accepted && optinConfirm && generation === messageGeneration) optinConfirm.hidden = false;
      });
    }
    finishSending();
    showDone();
  }

  function afterHandoff() {
    const params = new URLSearchParams(window.location.search);
    const key = params.get('form_key');
    const posted = params.get('contact_posted') === 'true' || Boolean(form.querySelector('[data-message-posted]'));
    const restored = key && params.get('form_type') === 'contact';
    if (!posted && !restored) return;
    let saved = null;
    try {
      saved = JSON.parse(window.sessionStorage.getItem(handoffStorageKey) || 'null');
      if (saved && (saved.payload?.product_id !== productId || (key && saved.key !== key))) saved = null;
      if (saved) {
        window.sessionStorage.removeItem(handoffStorageKey);
        window.sessionStorage.removeItem(saved.key);
      }
    } catch (error) {
      saved = null;
    }
    if (posted) {
      if (!saved) return;
      try {
        const clean = new URL(window.location.href);
        for (const name of ['contact_posted', 'form_key', 'form_type']) clean.searchParams.delete(name);
        window.history.replaceState(window.history.state, '', clean.href);
      } catch (error) {
      }
      form.querySelector('[data-message-posted]')?.remove();
      comeBack();
      confirmSent(saved.payload, saved.email, saved.name);
      return;
    }
    if (saved) {
      chipUsed = saved.chip;
      if (optin) optin.checked = saved.payload.opted_in;
    }
    const chipField = field('chip');
    if (chipField && chipField.value) chipField.disabled = false;
    comeBack();
    const errors = form.querySelector('[data-message-server-errors]');
    if (status) status.textContent = errors
      ? (errors.textContent || '').replace(/\s+/g, ' ').trim()
      : 'Your message is ready. Press Send message to send it.';
    title?.focus();
    prebind();
  }

  const FAILED = "We couldn't send your message just now.";

  async function send() {
    if (nativeNext) {
      nativeNext = false;
      clearTimeout(handoffTimer);
      try {
        HTMLFormElement.prototype.submit.call(form);
      } catch (error) {
        sending = false;
        fail(FAILED, 'handoff-error');
      }
      return;
    }
    if (sendStarted || !payload) return;
    sendStarted = true;
    clearInterval(tokenWatch);
    comeBack();
    const id = selectedVariantId();
    if (id) setVariant(id);
    payload = sentPayload();
    optinEmail = input('email')?.value.trim() || '';
    optinName = input('name')?.value.trim().replace(/\s+/g, ' ') || '';
    const body = new FormData(form);
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), SEND_TIMEOUT_MS);
    let result;
    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body,
        headers: { Accept: 'text/html' },
        signal: controller.signal,
      });
      result = { ...(await classify(response)), status: response.status };
    } catch (error) {
      result = { outcome: error && error.name === 'AbortError' ? 'timeout' : 'network' };
    } finally {
      clearTimeout(timer);
    }

    if (result.outcome === 'sent') {
      const sent = payload;
      payload = null;
      confirmSent(sent, optinEmail, optinName);
      return;
    }
    if (result.outcome === 'challenge') {
      showHandoff();
      return;
    }
    fail(result.outcome === 'invalid' && result.message ? result.message : FAILED, `post-${result.outcome}${result.status ? `-${result.status}` : ''}`);
  }

  function challengeOnScreen() {
    for (const frame of document.querySelectorAll('iframe[src*="hcaptcha"]')) {
      if (!/[#&]frame=challenge\b/.test( (frame).src)) continue;
      const box = frame.parentElement;
      if (!box || getComputedStyle(box).visibility !== 'visible') continue;
      const rect = frame.getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight) return true;
    }
    return false;
  }

  function waitForToken() {
    const started = Date.now();
    let seenAt = 0;
    let goneAt = 0;
    clearInterval(tokenWatch);
    tokenWatch = setInterval(() => {
      if (sendStarted || !sending) {
        clearInterval(tokenWatch);
        return;
      }
      const onScreen = challengeOnScreen();
      if (onScreen) {
        seenAt = seenAt || Date.now();
        goneAt = 0;
        if (dialog.open && !steppedAside) {
          steppedAside = true;
          dialog.close();
        }
        return;
      }
      if (seenAt) {
        goneAt = goneAt || Date.now();
        if (Date.now() - goneAt > CHALLENGE_GRACE_MS) {
          fail('The check was not finished, so your message is not sent yet. Press Send message to try again.', 'check-unanswered');
        }
        return;
      }
      if (Date.now() - started > TOKEN_WAIT_MS) fail(FAILED, 'token-timeout');
    }, 250);
  }

  try {
    Object.defineProperty(form, 'submit', { value: () => send(), configurable: true, writable: true });
  } catch (error) {
  }

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    if (needsHandoff) {
      event.stopImmediatePropagation();
      status?.querySelector('button')?.focus();
      return;
    }
    if (sending || !validate()) {
      event.stopImmediatePropagation();
      return;
    }
    sending = true;
    if (status) status.textContent = '';
    if (submit) {
      submit.disabled = true;
      submit.setAttribute('data-divano-busy', '');
      submit.setAttribute('aria-busy', 'true');
      submit.textContent = 'Sending…';
    }
    clearTimeout(slowNote);
    slowNote = setTimeout(() => {
      if (sending && status && !status.textContent) status.textContent = SLOW_NOTE;
    }, SLOW_NOTE_MS);
    const id = selectedVariantId();
    if (id) setVariant(id);
    payload = sentPayload();

    if (form.hasAttribute('data-hcaptcha-bound')) {
      waitForToken();
      return;
    }
    const captcha =  (window).Shopify?.captcha;
    if (captcha && typeof captcha.protect === 'function') {
      event.stopImmediatePropagation();
      const giveUp = setTimeout(() => fail(FAILED, 'bind-timeout'), BIND_WAIT_MS);
      try {
        captcha.protect(form, () => {
          clearTimeout(giveUp);
          if (!sending || sendStarted) return;
          waitForToken();
          form.submit();
        });
      } catch (error) {
        clearTimeout(giveUp);
        fail(FAILED, 'bind-error');
      }
      return;
    }
    send();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', afterHandoff, { once: true });
  else afterHandoff();
}

if (!( (window).__divanoMessageForm)) {
   (window).__divanoMessageForm = true;
  init();
}
